import { cn, InputOtp, InputOtpProps } from '@heroui/react'
import type { FieldProps } from 'formik'
import { Field } from 'formik'
import { motion } from 'framer-motion'

export interface OtpFormikProps extends Omit<InputOtpProps, 'classNames'> {
  label?: string
  classNameContainer?: string
  classNames?: {
    base?: string
    input?: string[]
    inputWrapper?: string[]
    segmentWrapper?: string
  }
  name: string
  isRequired?: boolean
}

const OtpFormik = ({
  classNameContainer,
  classNames,
  name,
  isRequired = false,
  ...props
}: OtpFormikProps) => {
  return (
    <Field name={name}>
      {({ field, meta, form }: FieldProps) => {
        const isInvalid = Boolean(meta.error && meta.touched)

        const handleChange = (value: string) => {
          form.setFieldValue(name, value)
          form.setFieldTouched(name, true, false)
        }

        return (
          <motion.div className={cn(classNameContainer)}>
            <InputOtp
              errorMessage={isInvalid && meta.error ? meta.error : 'error'}
              isInvalid={isInvalid}
              isRequired={isRequired}
              value={field.value}
              variant="bordered"
              classNames={{
                segment: ['!text-gray-900', 'dark:!text-white'],
                ...classNames,
              }}
              onValueChange={handleChange}
              {...props}
            />
          </motion.div>
        )
      }}
    </Field>
  )
}

export default OtpFormik
